// extracted by mini-css-extract-plugin
export default {"icon-button":"buttons_icon-button__Rp2e4","icon-holder":"buttons_icon-holder__rV2Wn","copy-holder":"buttons_copy-holder__rE8s+","arrow-holder":"buttons_arrow-holder__vKIpI"};